/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=076ac2a4&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"
import style0 from "./rank.vue?vue&type=style&index=0&id=076ac2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ac2a4",
  null
  
)

export default component.exports